import {
  GET_PROVIDER_SUB_CATEGORY,
  GET_PROVIDER_SUB_CATEGORY_FAILURE,
  GET_PROVIDER_SUB_CATEGORY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getProviderServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_SUB_CATEGORY:
      return { ...state, loading: true };
    case GET_PROVIDER_SUB_CATEGORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_PROVIDER_SUB_CATEGORY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getProviderServiceReducer;
